var _performance_timing;
var TeaPerfMetricName;
(function(TeaPerfMetricName2) {
  TeaPerfMetricName2["FBJS"] = "pns_privacy_product_mark_fbjs";
  TeaPerfMetricName2["AFMP"] = "pns_privacy_product_mark_afmp";
})(TeaPerfMetricName || (TeaPerfMetricName = {}));
const NAVIGATE_TIME = ((_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart) || performance.timeOrigin;
export {
  NAVIGATE_TIME,
  TeaPerfMetricName
};
